import * as React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { createColumnClasses } from './grid-style';
import { IGridProps } from './grid-props';
import { GridSystemStylesProvider } from './grid-system-style-context';

const GridBase = React.memo((props: IGridProps) => {
    const { semantics: { layout: { columnsCount: columnCountFromTheme } } } = useTheme();
    const { children, elementRef, className, columnsCount = columnCountFromTheme, hidden } = props;
    const classes = React.useMemo(() => createColumnClasses(columnsCount, props.noGutter), [columnsCount, props.noGutter]);

    return hidden ? null : (
        <div ref={elementRef} className={className}>
            <GridSystemStylesProvider value={{ classes }}>
                {children}
            </GridSystemStylesProvider>
        </div>
    );
});

GridBase.displayName = 'Grid';

const withGutter = css`
    margin: 0 -0.5rem;
`;

const noWrap = css`
    flex-wrap: nowrap;
`;

const justifyContentRight = css`
    justify-content: flex-end;
    align-self: flex-end;
    margin-left: auto;
`;

const GridStyledBase = styled(GridBase).attrs({
    className: String('ap-grid')
})`
    box-sizing: border-box;
    display: flex;
    flex-flow: row;
    ${props => props.flexDirection && css`
        flex-direction: ${props.flexDirection};
    `};
    ${props => (props.justifyContent === 'right' ?
        justifyContentRight :
        css`justify-content: ${props.justifyContent};`)}
    flex-wrap: ${props => (props.noWrap ? 'nowrap' : 'wrap')};
    ${props => (!props.noGutter && withGutter)}
    ${props => (props.noWrap && noWrap)}
`;

export const Grid = React.memo<IGridProps>(GridStyledBase);
